module.exports = __webpack_public_path__ + "img/neutral.60812e36.svg";